import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { logClientError } from "./lib/log-client-error.ts";
import "./lib/patch-dom-for-translate.ts";
import "./lib/tolerate-css-preload-error.ts";
import "./index.css";
import { initConsent } from "./lib/consent.ts";

// Catches what the React error boundary can't: errors thrown outside render
// (event handlers, timeouts) and unhandled promise rejections.
window.addEventListener("error", (e) => {
  logClientError("window-error", e.error ?? e.message);
});
window.addEventListener("unhandledrejection", (e) => {
  // supabase-js auth lock contention: the newer request wins and the session
  // stays valid, so the rejected one is noise.
  const msg = e.reason instanceof Error ? e.reason.message : String(e.reason ?? "");
  if (msg.includes("was stolen by another request")) {
    e.preventDefault();
    return;
  }
  logClientError("unhandled-rejection", e.reason);
});

initConsent();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>,
);
